<template>
  <div class="menu-trip-planner">
    <v-img
      class="menu-trip-planner__image"
      :src="tripPlannerItem.image"
      width="100%"
      height="300px"
    />
    <v-row
      align="center"
      justify="center"
      class="menu-trip-planner__body-container"
    >
      <v-col
        cols="8"
      >
        <div class="menu-trip-planner__body">
          <h2>{{ tripPlannerItem.title }}</h2>

          <div class="plan-your-trip__btn">
            <a :href="tripPlannerItem.url" class="btn-animated">
              <span class="square">
                <v-icon
                  class="chevron-icon"
                  color="#fff"
                  size="40px"
                >
                  {{ icons.chevron }}
                </v-icon>
              </span>
              <span class="btn-text"><strong>{{ tripPlannerItem.cta }}</strong></span>
            </a>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mdiChevronRight } from '@mdi/js'

  export default {
    name: 'TheMenuTripPlanner',

    props: {
      tripPlannerItem: {
        required: true,
        type: Object,
      },
    },

    data() {
      return {
        icons: {
          chevron: mdiChevronRight,
        },
      }
    },
  }
</script>

<style lang="sass" scoped>
  .menu-trip-planner
    position: relative

    &__image:after
      content: ""
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      background-color: #fff
      opacity: 0.5
      z-index: 1

    &__body-container
      position: absolute
      top: 0
      left: 0
      width: 100%

    &__body
      margin-top: 100px

    h2
      font-size: 30px
      text-transform: uppercase
      margin-bottom: 20px

    .btn-animated
      position: relative
      display: -webkit-box
      display: -ms-flexbox
      display: flex
      justify-items: flex-start
      -webkit-box-align: center
      -ms-flex-align: center
      align-items: center
      cursor: pointer
      outline: none
      border: 0
      text-decoration: none
      background: transparent
      padding: 0
      font-size: inherit
      font-family: inherit
      width: 160px
      height: auto

      .btn-text
        transition: all 0.45s cubic-bezier(0.65, 0, 0.08, 1)
        position: absolute
        top: 0
        left: 3.5rem
        right: 0
        bottom: 0
        display: flex
        justify-items: flex-start
        align-items: center
        color: #282936
        line-height: 1
        font-size: 1rem

      .square
        transition: all 0.45s cubic-bezier(0.65, 0, 0.08, 1)
        position: relative
        display: block
        margin: 0
        width: 2.5rem
        height: 2.5rem
        background: #282936

      &:hover .v-icon
        color: #fff

      &:hover .square
        width: 160px

      &:hover .btn-text
        color: #fff

  @media (max-width: 960px)
    .menu-trip-planner__body
      margin-top: 65px
</style>
